import * as React from "react";
import { useTranslation } from "react-i18next";

import AuditLogsTable from "./AuditLogsTable";
import ExportIcon from "components/icons/ExportIcon";
import ApplicationLayout from "components/layout/ApplicationLayout";
import { AUDIT_LOGS_ROUTE } from "components/router/Routes";
import { Action, Category, usageStatisticsService } from "services/statistics/UsageStatisticsService";
import buttons from "styles/buttons.scss";
import { useTheme } from "utils/useTheme";

import testIds from "testIds.json";

export default function AuditLogsView() {
    const { t } = useTranslation();
    const theme = useTheme();
    const [refreshCount, setRefreshCount] = React.useState(0);
    const [hasData, setHasData] = React.useState(false);
    const exportAllRef = React.useRef<(() => void) | undefined>(undefined);

    React.useEffect(() => {
        usageStatisticsService.sendEvent({
            category: Category.AUDIT_LOGS,
            action: Action.VIEW_AUDIT_LOGS,
        });
    }, []);

    const handleExportAllReady = React.useCallback((handler: () => void) => {
        exportAllRef.current = handler;
    }, []);

    const exportButton = hasData && (
        <button
            className={buttons.primaryButton}
            data-testid={testIds.workArea.auditLogs.logs.exportButton}
            onClick={() => exportAllRef.current?.()}
        >
            <ExportIcon color={theme.whiteColor} />
            {t("AuditLogs.exportAll")}
        </button>
    );

    return (
        <ApplicationLayout
            viewTitle={t("Routes.logs")}
            view={
                <AuditLogsTable
                    refreshCount={refreshCount}
                    onDataLoaded={setHasData}
                    onExportAllReady={handleExportAllReady}
                />
            }
            mainRoute={AUDIT_LOGS_ROUTE}
            enableRefresh={true}
            onHandleRefresh={() => setRefreshCount((c) => c + 1)}
            viewActions={exportButton || undefined}
        />
    );
}
